import styled from '@xstyled/styled-components';
import { Swiper } from 'swiper/react';
import { FlexCenter } from '@/UI/utils';

export const BrandsContainer = styled.section`
  padding: 4rem 0;
  min-height: 40vh;

  @media (max-width: desktop) {
    min-height: 100vh;
    padding: 0 1rem 4rem;
  }
`;

export const Alphabet = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 2rem;

  span {
    margin-right: 1rem;
    text-transform: uppercase;
    font-weight: 700;
    color: #242424;
    cursor: pointer;

    &:hover {
      color: #54c8e6;
    }
  }

  @media (max-width: desktop) {
    display: none;
  }
`;

export const BrandsByLetter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.25rem;
`;

export const BrandsBox = styled.divBox`
  display: grid;
  grid-template-columns: 60px 1fr;
  margin-bottom: 3rem;
  border: 0.7px solid #d8d9e5;
  border-radius: 22px;
  overflow: hidden;

  span {
    padding: 1rem 0 0 1rem;
    color: teal-400;
    font-size: large;
    font-weight: 700;
    text-transform: uppercase;
  }

  @media (max-width: desktop) {
    display: flex;

    span {
      padding: 1rem 2rem 0 1rem;
    }
  }
`;

export const SingleBrand = styled.div`
  ${FlexCenter};

  flex-direction: column;
  margin-right: 2rem;

  @media (max-width: desktop) {
    margin-bottom: 2rem;
  }

  @media (min-width: desktop) {
    margin-right: 1rem;
  }

  p {
    white-space: nowrap;
  }

  img {
    object-fit: contain;
  }
`;

// Alphabet carousel

export const SelectionContainer = styled.div`
  display: flex;
  flex-direction: column;

  span:first-of-type {
    margin: 2rem 0 0.5rem;

    @media (min-width: desktop) {
      display: none;
    }
  }
`;

export const Alpha = styled.span`
  font-weight: 700;
  color: ${({ selected }) => (selected ? '#54C8E6' : '#242424')};
`;

export const AlphabetSwiperContainer = styled.div`
  display: flex;

  @media (min-width: desktop) {
    display: none;
  }
`;

export const AlphabetSwiper = styled(Swiper)`
  width: 80vw;
  margin-top: 0.5rem;

  .swiper-slide {
    display: block;
    width: auto;

    span {
      font-size: 18px;
    }
  }
`;

export const Arrow = styled.div`
  position: relative;
  bottom: 0.25rem;
  right: ${({ prev }) => prev && '0.5rem'};
  padding-left: ${({ next }) => next && '0.5rem'};
  z-index: 1;
  background-color: white;

  svg {
    transform: scale(0.7);
  }
`;
